interface Props {
  /** Pixel size of the spinner. Defaults to 16 (h-4/w-4). */
  size?: number;
  /** Optional caption shown next to the spinner. */
  label?: string;
  className?: string;
}

/**
 * Simple indeterminate spinner. Pure CSS via Tailwind's `animate-spin`
 * so we don't ship any animation libraries.
 */
export default function Spinner({ size = 16, label, className }: Props) {
  return (
    <div className={`inline-flex items-center gap-2 text-sm text-gray-400 ${className ?? ""}`}>
      <span
        className="inline-block animate-spin rounded-full border-2 border-gray-700 border-t-accent"
        style={{ width: size, height: size }}
        aria-label={label ?? "Loading"}
      />
      {label && <span>{label}</span>}
    </div>
  );
}
